import { Box, Grid } from '@mui/material';
import React from 'react';
import call from 'assets/images/icons/call.svg';
import email from 'assets/images/icons/email.svg';
import FormProvider from 'common/components/form-provider';
import BaseTextField from 'common/components/base-text-field';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const phoneSchema = Yup.object().shape({
    phone: Yup.string()
        .required('Vui lòng nhập số điện thoại')
        .matches(/^[0-9]{10,11}$/, 'Số điện thoại không hợp lệ'),
});

const Footer: React.FC = () => {
    const methods = useForm({
        resolver: yupResolver(phoneSchema),
        defaultValues: {
            phone: '',
        },
    });
    const handleSubmit = methods.handleSubmit((data) => {
        console.log(data);
    });
    return (
        <Box
            mt={3}
            sx={{
                borderBottom: '1px solid var(--color-primary)',
                p: '32px 0px',
            }}
        >
            <Grid
                container
                justifyContent={'space-around'}
                sx={{ gap: [2, 0] }}
            >
                <Grid item xs={12} md={3}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <img src={call} alt="call" />{' '}
                        <b style={{ color: '#5E5E5E' }}>HOTLINE 0902.598.228</b>
                    </Box>
                </Grid>
                <Grid xs={12} md={3}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <img src={email} alt="call" />{' '}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <b style={{ color: '#5E5E5E' }}>EMAIL</b>
                            <span style={{ color: '#5E5E5E' }}>
                                congtykhaosatthat@gmail.com
                            </span>
                        </Box>
                    </Box>
                </Grid>
                <Grid xs={12} md={3}>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            flexDirection: 'column',
                        }}
                    >
                        <b style={{ color: '#5E5E5E' }}>ĐĂNG KÝ TƯ VẤN</b>
                        <FormProvider methods={methods} onSubmit={handleSubmit}>
                            <BaseTextField
                                size="small"
                                name="phone"
                                placeholder="Nhập số điện thoại của bạn"
                                sx={{
                                    '& .MuiInputBase-root': {
                                        border: '1px solid #7B61FF',
                                        borderRadius: '999px',
                                        paddingRight: 0,
                                        overflow: 'hidden',
                                        pl: 2,
                                        height: '40px',
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: '8px',
                                        fontSize: '14px',
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    },
                                    '&::placeholder': {
                                        color: '#aaa',
                                    },
                                    width: '100%',
                                    maxWidth: 500,
                                    display: 'flex',
                                    position: 'relative',
                                    pr: 0,
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <button
                                            type="submit"
                                            style={{
                                                background:
                                                    'var(--color-primary)',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '50px',
                                                padding: '10px 24px',
                                                cursor: 'pointer',
                                                fontWeight: 500,
                                                minWidth: '120px',
                                                height: '100%',
                                            }}
                                        >
                                            Gửi ngay
                                        </button>
                                    ),
                                }}
                            />
                        </FormProvider>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Footer;
